import { I02CHOIXENERCHAUF_State } from '@batical/types/src'

const I02CHOIXENERCHAUF: I02CHOIXENERCHAUF_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  rendementProduction_uuid: 'ENER1',
  in_consommation: 20000.0,
  in_rendementProduction1: 0.98,
  in_ancienneFactureEnergie: 0.0,
  rendementProduction_uuid2: 'ENER2',
  in_rendementProduction2: 3,
  in_coutInstallDevis: 8000.0,
  in_aidecredit: 0,
  in_coutNewEnergie: 0,
  in_emiCO2new: 0,
  in_surcout: 140.0,
  res_consoAnnuelEstime: 0.0,
  res_exProdCO2: 0.0,
  res_newProdCO2: 0.0,
  res_gainCO2: 0.0,
  res_temptri: 0.0,
  unite_gainco2: 'kg/an',
  unite_exgainco2: 'kg/an',
  unite_newProdco2: 'kg/an',
  in_hausseAncien: 0.027,
  in_hausseNew: 0.01,
  mode: 'none',
  calcul_code: 'I02CHOIXENERCHAUF'
}

export default I02CHOIXENERCHAUF
